import { useNavigate } from "react-router-dom";

// project imports
import { GuardProps } from "types";
import { useEffect } from "react";

import { useAppSelector } from "store/hooks";
import { LOGIN_ROUTE } from "constants/routes";

// ==============================|| AUTH GUARD ||============================== //

/**
 * Authentication guard for routes
 * @param {PropTypes.node} children children element/node
 */
const AuthGuard = ({ children }: GuardProps) => {
  const { isLoggedIn } = useAppSelector((state) => state.user);

  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoggedIn) {
      navigate(LOGIN_ROUTE, { replace: true });
    }
  }, [isLoggedIn, navigate]);

  return children;
};

export default AuthGuard;
